import { render, staticRenderFns } from "./rule-sets.vue?vue&type=template&id=66350f3f&scoped=true&"
import script from "./rule-sets.vue?vue&type=script&lang=ts&"
export * from "./rule-sets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66350f3f",
  null
  
)

export default component.exports